<div
  class="bg-foreground rounded-xl border border-divider p-4 h-full flex flex-col">
  <div class="flex items-center gap-2 mb-3">
    <div
      class="w-8 h-8 rounded-lg flex items-center justify-center bg-green-600/10 text-green-600">
      <mat-icon
        svgIcon="mat:point_of_sale"
        class="w-4 h-4"
        style="font-size: 18px"></mat-icon>
    </div>
    <span class="text-sm font-medium text-default flex-auto">Open Shifts</span>
    @if (!isLoading(item) && !isError(item)) {
      <span class="text-xs font-semibold bg-base rounded-full px-2 py-0.5">{{
        item.data.length
      }}</span>
    }
  </div>

  @if (isLoading(item)) {
    <div class="flex flex-col gap-2 flex-auto">
      @for (i of [1, 2]; track $index) {
        <div class="h-14 bg-base rounded animate-pulse"></div>
      }
    </div>
  } @else if (isError(item)) {
    <app-widget-error
      appClickStopPropagation
      (retry)="retry.emit()"></app-widget-error>
  } @else if (item.data.length === 0) {
    <p class="text-sm text-secondary py-4 text-center">No open shifts</p>
  } @else {
    <div class="flex flex-col gap-2 flex-auto overflow-y-auto max-h-48">
      @for (shift of item.data; track $index) {
        <div class="border border-divider rounded-lg p-3">
          <div class="flex items-center justify-between">
            <p class="text-sm font-medium text-default">
              {{ shift.cashierUser.firstName }} {{ shift.cashierUser.lastName }}
            </p>
            <span class="text-xs text-green-600 font-medium">Open</span>
          </div>
          <p class="text-xs text-secondary mt-1">
            Since {{ shift.openedAt | date: "shortTime" }} ·
            {{ shift.transactionCount }} txns
          </p>
        </div>
      }
    </div>
    <div class="w-full flex justify-start px-2">
      <a
        [routerLink]="linkToOpenShifts"
        class="flex items-center justify-center gap-1 text-xs text-primary-600 mt-3 hover:underline">
        <span>View all</span>
        <mat-icon
          svgIcon="mat:chevron_right"
          class="w-3 h-3"
          style="font-size: 14px"></mat-icon>
      </a>
    </div>
  }
</div>
